import React from 'react';
import moment from 'moment';

import { SearchTextField, SelectField, MCButton, PopoverMenu } from 'src/components/basic';
import { TableLibrary } from 'src/components/complex';
import BaseComponent from 'src/components/BaseComponent';
import SVGIcon, { BASE_ICONS } from 'src/components/svg';
import AlertManager from 'src/components/alert/AlertManager';

import { remCss, lang, upperFirstChar, withRouter, permissions } from 'src/helpers';

import model from './model';
import ShortInfo from 'src/components/user/ShortInfo';
import LANG_CONST from 'src/helpers/lang/const';

class Patients extends BaseComponent {
  componentDidMount() {
    model.subscribe(this.subscription);
    if (!model.initFlag) {
      model.refresh();
      model.initFlag = true;
    }
  }

  componentWillUnmount() {
    model.unsubscribe(this.subscription);
    model.initFlag = false;
  }

  render() {
    let loading = model.refreshing();
    let noResults = model.noResults();
    let searchQuery = model.listInput('search');
    let items = model.items();
    let { total = 0 } = model.getCurrent();
    const columns = [
      {
        label: 'Name',
        resize: true,
        renderCell: (item) => {
          return (
            <ShortInfo
              user={item}
              to={permissions.PAGES.ADMIN_PATIENTS_DETAIL_PAGE.match(item.id)}
            />
          );
        }
      },
      {
        label: 'Added date',
        resize: true,
        renderCell: (item) => (item.created ? moment(item.created).format('MMMM DD, YYYY') : '')
      },
      {
        label: 'Last appointment',
        resize: true,
        renderCell: (item) =>
          item.lastAppointment ? moment(item.lastAppointment).format('DD - MMMM - YYYY') : ''
      },
      {
        label: 'Status',
        resize: true,
        renderCell: (item) => (
          <button className={'mc-status-' + item.status}>{upperFirstChar(item.status)}</button>
        )
      },
      {
        label: 'Actions',
        cellStyles: { textAlign: 'end' },
        width: `${remCss(190)}px`,
        renderCell: (item) => (
          <div className={'mc-flex'} style={{ justifyContent: 'flex-end' }}>
            <MCButton
              to={'/admin/clients/' + item.id + '/edit'}
              type={'link'}
              style={{ minWidth: remCss(33) }}
              iconname={BASE_ICONS.EDIT}
              width={33}
              light
              radius
            />
            <MCButton
              label={'Login'}
              small
              radius
              primary
              dark
              onClick={() => {
                permissions.switchToFront();
                model.emit('login_as_other_user', { id: item.id });
              }}
            />
            <PopoverMenu
              placement={'bottom-end'}
              menu={() => (
                <ul
                  className={'mc-select-field-items'}
                  style={{
                    backgroundColor: 'white',
                    padding: remCss(10)
                  }}
                >
                  <li>
                    <MCButton
                      type={'button'}
                      iconname={BASE_ICONS.CLOSE}
                      width={48}
                      padding={7}
                      light
                      radius
                      secondary
                      onClick={() =>
                        AlertManager.popup(AlertManager.TYPES.WARN, {
                          close: false,
                          title: LANG_CONST.notice.delete,
                          cancelButton: {
                            label: LANG_CONST.buttons.no,
                            action: (actions) => actions.hide()
                          },
                          actionButton: {
                            label: LANG_CONST.buttons.yes,
                            action: (actions) => {
                              actions.setLoading(true);
                              model.remove(item.id, (err, res, success) => {
                                actions.setLoading(false);
                                if (success) {
                                  actions.hide();
                                } else {
                                  alert(`error: ${err}`);
                                }
                              });
                            }
                          }
                        })
                      }
                    />
                  </li>
                </ul>
              )}
              className={'mc-no-style-btn'}
            >
              {() => <SVGIcon iconname={BASE_ICONS.DOTS} width={30} />}
            </PopoverMenu>
          </div>
        )
      }
    ];

    return (
      <div className={'mc-container-content mc-all-patients'}>
        <div className={'mc-container-content__header mc-flex-15'}>
          <span className={'mc-grow'}>{lang.t(LANG_CONST.clients)}</span>
          <SearchTextField
            width={300}
            template={'2'}
            onChange={(text) => {
              model.setStateSilent({
                pageIndex: 0
              });
              model.setListStateSilent({ items: [], total: 0 }, 'search');
              model.handleChangeSearch(text);
              if (!text) {
                model.setListState({ items: [] }, model.getCurrentId(), null, true);
                model.refresh();
              }
            }}
            value={model.listInput('search')}
          />
          <SelectField
            width={remCss(150)}
            isClearable={false}
            style={{ zIndex: 3 }}
            template={'6'}
            options={[
              { value: 'all', label: 'All' },
              { value: 'active', label: 'Active' },
              { value: 'inactive', label: 'Inactive' }
            ]}
            name={'status'}
            value={model.input('status')}
            onChange={(n, v) => {
              if (v.toString() === model.input('status').toString()) return;
              model.setStateSilent({
                pageIndex: 0,
                status: v
              });
              model.setListState({ items: [], total: 0 }, model.getCurrentId(), null, true);
              model.refresh();
            }}
          />
        </div>
        <div className={'mc-container-content__body'}>
          <div className={'mc-container-content__body-content'} style={{ marginTop: remCss(25) }}>
            <TableLibrary
              loading={loading}
              noResults={noResults}
              searchQuery={searchQuery}
              sortBy={model.state.sortBy}
              selectedPage={model.state.pageIndex}
              total={total}
              limit={model.listLimit}
              onSortChange={(sortBy) => {
                model.handleChange('sortBy', sortBy);
                model.setListState({ items: [] }, model.getCurrentId(), null, true);
                model.loadMore();
              }}
              onSetPage={(v) => {
                model.handleChange('pageIndex', v);
                model.setListState({ items: [] }, model.getCurrentId(), null, true);
                model.loadMore();
              }}
              columns={columns}
              data={items}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(Patients);
